































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiFlux from '@/api/flux'
import EditItemFlux from '@/components/flux/edit/EditItemFlux.vue'
import { AloItemflux } from '@/models/alo/AloItemflux'
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { directPayloadQuery } from '@/utils/api'

@Component({
  name: 'ReadItemFlux',    
  components:{EditItemFlux},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    direction:{
      type:Number,
      default:0,
      required:true
    },
    itemsFlux:{
      type:Array,
      default:[],
      required:true
    },
    fluxId:{
      type:Number,
      default:0,
      required:true
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadItemFlux extends Vue {
  
  private itemsFlux!:Array<AloItemflux>
  private loading!:boolean
  private direction!:number
  private fluxId!:number

  private headersCat = [
    { text: 'Univers', value: 'univers', width:'32%'  },
    { text: 'Rubrique', value: 'rubrique', width:'32%'  },
    { text: 'Famille', value: 'famille', width:'32%' },
    { text: '', value: 'action', width:20 },
  ]
  

  get title() {
    return this.direction?"Sélection des catégories à exporter":"Sélection des catégories à exclure du flux"
  }

  
  edit() { (this.$refs.editItemFlux as EditItemFlux).edit(this.itemsFlux,this.fluxId,this.direction) }

  get isCatalogue() {
    return this.itemsFlux.some(it => it.itfFid == 0 && it.itfDirection == this.direction && it.itfTypObj == ItemfluxObjectType.Catalogue)
  }

  get items(){
    return this.extendItemFlux(this.itemsFlux.filter(it => it.itfDirection == this.direction))
  }

  itemRowBackground(item:any) {
     return item.isAlive? '' : 'red--text'
  }
 
  extendItemFlux(items:Array<AloItemflux>){
    return items.map(it => {
      return {
        ...it,
        isAlive:(it.itfTypObj==ItemfluxObjectType.Univers?this.univers[it.itfFid].uniIsAlive:(it.itfTypObj==ItemfluxObjectType.Rubrique?this.rubriques[it.itfFid].rubIsAlive:this.familles[it.itfFid].famIsAlive)),
        univers:(it.itfTypObj==ItemfluxObjectType.Univers?this.univers[it.itfFid].libelle:
                  (it.itfTypObj==ItemfluxObjectType.Rubrique)?this.univers[this.rubriques[it.itfFid].uniId].libelle:
                  this.univers[this.familles[it.itfFid].uniId].libelle),
        rubrique:(it.itfTypObj==ItemfluxObjectType.Univers?'':
                  (it.itfTypObj==ItemfluxObjectType.Rubrique)?this.rubriques[it.itfFid].libelle:
                  this.rubriques[this.familles[it.itfFid].rubId].libelle),
        famille:it.itfTypObj==ItemfluxObjectType.Famille?this.familles[it.itfFid].libelle:''
      }
    }).sort((a,b) => (a.univers+a.rubrique+a.famille).localeCompare(b.univers+b.rubrique+b.famille))
  }

  get univers(){
    return this.$store.myGetters.univers
  }

  get rubriques(){
    return this.$store.myGetters.rubriques
  }

  get familles(){
    return this.$store.myGetters.familles
  }

  deleteItemFlux(item:any) {
    this.$confirm(`Voulez vous vraiment supprimer l'item : '${item.univers} ${item.rubrique?'/':''} ${item.rubrique} ${item.famille?'/':''} ${item.famille}' ${this.direction?'des catégories à exporter':'des catégories à exclure du flux'}?`
                  ,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
      if(answer) {                       
        const idx = this.itemsFlux.findIndex(it => it.id == item.id)     
        if(idx > -1)  {
          this.$set(item,"deleted",true);          
          this.itemsFlux.splice(idx,1)
          directPayloadQuery(apiFlux.saveItemFlux,{id:this.fluxId,fluxItems:this.itemsFlux},this.$store)                    
        }        
      }
    })
  }

}
